<h1>
  {{ printFormatId | printFormatLabel | async }}
  {{ printPaperId | printPaperLabel | async }}
</h1>
<mat-dialog-content> </mat-dialog-content>
<mat-dialog-actions>
  <lib-button mat-dialog-close forceContext="common" translate>close</lib-button>
</mat-dialog-actions>
